/* new custom js  */

$('.shop-slider-22').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$('ul.you-may-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$('ul.men-wear-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$('ul.cotton-t-slider').slick({
  dots: false,
  infinite: true,
  speed:1200,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});



$('ul.green-cotton-slider').slick({
  dots: false,
  infinite: true,
  speed:1200,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$('ul.Printed-Salwar-slider').slick({
  dots: false,
  infinite: true,
  speed:1200,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$('ul.shop-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});






$('ul.you-may-also').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$('ul.home-slider').slick({
  dots: false,
  infinite: true,
  speed: 1200,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 3000,
});



$(".descrip .according-box:nth-child(1) h4").click(function(){
  $(".descrip .according-box:nth-child(1) span").toggle();
  $(".descrip .according-box:nth-child(2) span").hide();
  $(".descrip .according-box:nth-child(3) span").hide();
  $(".descrip .according-box:nth-child(4) span").hide();
  $(".descrip .according-box:nth-child(5) span").hide();
});

$(".descrip .according-box:nth-child(2) h4").click(function(){
  $(".descrip .according-box:nth-child(2) span").toggle();
  $(".descrip .according-box:nth-child(1) span").hide();
  $(".descrip .according-box:nth-child(3) span").hide();
  $(".descrip .according-box:nth-child(4) span").hide();
  $(".descrip .according-box:nth-child(5) span").hide();
});

$(".descrip .according-box:nth-child(3) h4").click(function(){
  $(".descrip .according-box:nth-child(3) span").toggle();
  $(".descrip .according-box:nth-child(1) span").hide();
  $(".descrip .according-box:nth-child(2) span").hide();
  $(".descrip .according-box:nth-child(4) span").hide();
  $(".descrip .according-box:nth-child(5) span").hide();
});

$(".descrip .according-box:nth-child(4) h4").click(function(){
  $(".descrip .according-box:nth-child(4) span").toggle();
  $(".descrip .according-box:nth-child(1) span").hide();
  $(".descrip .according-box:nth-child(2) span").hide();
  $(".descrip .according-box:nth-child(3) span").hide();
  $(".descrip .according-box:nth-child(5) span").hide();
});

$(".descrip .according-box:nth-child(5) h4").click(function(){
  $(".descrip .according-box:nth-child(5) span").toggle();
  $(".descrip .according-box:nth-child(1) span").hide();
  $(".descrip .according-box:nth-child(2) span").hide();
  $(".descrip .according-box:nth-child(3) span").hide();
  $(".descrip .according-box:nth-child(4) span").hide();
});

  $("i.hide-box").click(function(){
    $(".size-box-full").hide();
  });
  $(".size-chart button").click(function(){
    $(".size-box-full").show();
  });






